export default __webpack_public_path__ + "static/media/photograph-outline.52ae94da.svg";